var account = "Konto";
var accountSettings = "Kontoindstillinger";
var charging = "Opladning";
var contactInfo = "Kontaktoplysninger";
var dashboard = "Dashboard ";
var home = "Hjem";
var myProducts = "Mine produkter";
var orderHistory = "Bestillingshistorik";
var paymentMethod = "Betalingsmetode";
var profileSettings = "Profilindstillinger";
var referAndEarn = "Henvis og optjen";
var signOut = "Log ud";
var da_DK = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, da_DK as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
